import React, { useEffect, useState } from 'react'
import { Button, Col, Form, Container, Row, InputGroup } from 'react-bootstrap'
import { ErrorMessage, Field, FormikProvider, useFormik } from 'formik';
import * as Yup from "yup";
import { useNavigate } from "react-router-dom";
import { BiUser } from "react-icons/bi";
import { FaEyeSlash } from 'react-icons/fa6';
import { config } from '../Components/CommonUtilities/CommonUrl/CommonUrls';
import { TfiReload } from 'react-icons/tfi';
import Sweetalert from '../Components/CommonUtilities/CommonPopupAndAlerts/SweetAlerts';
import axios from 'axios'; import { FaLock, FaMobileAlt } from 'react-icons/fa'
import { CommomLoginAunthenticatePost } from '../Components/CommonUtilities/CommonAxios/CommonAxios';
import { AADHAR_VALIDATION, Aadhaar_Msg, ERROR_MSG, MOBILE_VALIDATION, Mobile_Msg, PWD_REG, handleInputToUppercase, handleKeyPressNumeric } from '../Components/CommonUtilities/Validations/RegularExpAndVar';
import { IoMdTime, } from 'react-icons/io';

export default function ForgotPassword() {

    let navigate = useNavigate();
    /************    HIT TO LOGIN DETAILS API AND SEND TOKEN SET DETAILS ************/
    const submitDetails = async (values) => {
        let url = config.url.DSC_URL + "dsc-public/forgot-password"
        CommomLoginAunthenticatePost(url, values).then((res) => {
            if (res?.data?.status === true) {

                Sweetalert(res.data.sdesc, "success")
                navigate('/')
            } else {
                Sweetalert(res.data.sdesc, "error")
            }
        })

    }
    const userValidationSchema = Yup.object().shape({
        aadhaarNo: Yup.string().required(ERROR_MSG).matches(AADHAR_VALIDATION, Aadhaar_Msg),
        candidateId: Yup.string().required(ERROR_MSG).nullable(),
        // mobile: Yup.string().required(ERROR_MSG).nullable().matches(MOBILE_VALIDATION, Mobile_Msg),
        otp: Yup.string().required(ERROR_MSG),
        newPassword: Yup.string().required(ERROR_MSG).matches(PWD_REG,
            "Password must contain at least 8 characters, one uppercase, one number and one special case character").min(8).max(20),
        rePassword: Yup.string().required(ERROR_MSG).oneOf([Yup.ref("newPassword"), null], "Password doesn't match."),
    });
    const formIk = useFormik({
        initialValues: {
            "aadhaarNo": "",
            candidateId: "",
            // "mobile": "",
            "otp": "",
            "newPassword": "",
            rePassword: ""
        },
        validationSchema: userValidationSchema,
        onSubmit: submitDetails,
    });
    const [showOtpBtn, setOtpBtn] = useState(true)
    const [timer, setTimer] = useState(180); // Timer in seconds
    useEffect(() => {
        let interval = null;
        if (!showOtpBtn) {
            interval = setInterval(() => {
                setTimer((prevTimer) => {
                    if (prevTimer < 122) {
                        setResendOtp(true);
                        return prevTimer - 1;
                    } else if (prevTimer > 1) {
                        return prevTimer - 1;
                    }
                    else {
                        clearInterval(interval);
                        setResendOtp(true); // Enable resend button when timer reaches 0
                        return 0;
                    }
                });
            }, 1000);
        } else {
            clearInterval(interval);
        }
        return () => clearInterval(interval);
    }, [showOtpBtn]);
    const [resendOtp, setResendOtp] = useState(false);
    const [showMobileNo, setMobileNo] = useState("");
    function getOtp() {

        // if (formIk?.values?.aadhaarNo !== '' && formIk?.values?.mobile !== '') {
        if (formIk?.values?.aadhaarNo !== '' && formIk?.values?.candidateId !== '') {
            let otpUrl = config.url.DSC_URL + "dsc-public/otp-forgot-password"
            let values = {
                "aadhaarNo": formIk?.values?.aadhaarNo,
                "candidateId": formIk?.values?.candidateId,
                // "mobile": formIk?.values?.mobile,
            }
            axios.post(otpUrl, values).then((res) => {
                if (res?.data?.status === true) {
                    setMobileNo(res?.data?.sdesc);
                    setTimer(180);
                    setOtpBtn(false)
                }
                else if (res?.data?.status === false) {
                    setMobileNo("");
                    Sweetalert(res?.data?.sdesc, 'error')
                    setOtpBtn(true)

                }
            })
        }
        else {
            Sweetalert("Enter Valid AADHAAR & Mobile No.", 'warning')
        }


    }
    const formatTime = (timeInSeconds) => {
        if (isNaN(timeInSeconds) || timeInSeconds < 0) {
            return "0:00";
        }
        const minutes = Math.floor(timeInSeconds / 60);
        const seconds = timeInSeconds % 60;
        return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
    };
    const resendOTP = () => {
        setResendOtp(false);
        getOtp()
    };

    return (
        <FormikProvider value={formIk}>

            <div className='section mt-0 mt-lg-4'>
                <Container fluid>
                    <Row>
                        <Col xxl={6} xl={6} lg={6} md={12} sm={12} xs={12} className='nyay-right-part'>
                            <div className='nyay-login-page'>
                                <h4>Forgot Password ?</h4>
                                <Form onChange={formIk.handleChange} onSubmit={formIk.handleSubmit} className='nyay-form mt-4 mt-md-5'>

                                    {showOtpBtn === true ?
                                        <React.Fragment>
                                            <InputGroup className="mb-3">
                                                <InputGroup.Text id="basic-addon1" className="group_txt">
                                                    <BiUser className="font_size" />
                                                </InputGroup.Text>
                                                <Field
                                                    type="text"
                                                    name="aadhaarNo"
                                                    placeholder="Enter Your Aadhaar"
                                                    className="input-field form-control"
                                                    maxLength='12'
                                                    onKeyPress={(e) => { handleKeyPressNumeric(e); }}
                                                />
                                                <ErrorMessage
                                                    name="aadhaarNo"
                                                    component="div"
                                                    className="text-error"
                                                />
                                            </InputGroup>
                                            <InputGroup className="mb-3">
                                                <InputGroup.Text id="basic-addon1" className="group_txt">
                                                    <BiUser className="font_size" />
                                                </InputGroup.Text>

                                                <Field
                                                    type="text"
                                                    name="candidateId"
                                                    placeholder="Enter Your CandidateId"
                                                    className="input-field form-control"
                                                    maxLength='11'
                                                    onInput={(e) => { handleInputToUppercase(e) }}

                                                />
                                                <ErrorMessage
                                                    name="candidateId"
                                                    component="div"
                                                    className="text-error"
                                                />

                                                {/* <Field
                                                    type="text"
                                                    name="mobile"
                                                    placeholder="Enter Your Mobile No."
                                                    className="input-field form-control"
                                                    maxLength='10'
                                                    onKeyPress={(e) => { handleKeyPressNumeric(e); }}

                                                />
                                                <ErrorMessage
                                                    name="mobile"
                                                    component="div"
                                                    className="text-error"
                                                /> */}
                                            </InputGroup>
                                            <Button type="button" className='w-100 sign-in-button'
                                                onClick={() => { getOtp(); }}>Get OTP </Button>

                                            {/* <div className='mt-3'><a href='/ChangeMobileNo' className="float-start text-primary text-decoration-underline">Click Here To Change Mobile No</a></div> */}



                                        </React.Fragment>
                                        : showOtpBtn === false ?
                                            <React.Fragment>
                                                <Form.Label className="input-lable">
                                                    {/* OTP Sent to &nbsp;<b className='text-primary'>{formIk?.values?.mobile.slice(0, 3) + 'x'.repeat(5) + formIk?.values?.mobile.slice(8)} </b> */}
                                                    <b className='text-primary'>{showMobileNo} </b>

                                                </Form.Label><p6 className='float-end'>  Time Remaining:  <b className='text-danger'>{formatTime(timer)}</b> <IoMdTime size={20} />  </p6><br />

                                                {resendOtp === true &&
                                                    <span className='float-end'>
                                                        Didn't receive code? &nbsp;
                                                        <button className='btn btn-link' type='button' onClick={() => { resendOTP() }} style={{ textDecorationLine: 'underline' }}>Resend &nbsp;
                                                            <TfiReload size={17} /> </button></span>
                                                }
                                                <InputGroup className="mb-2">

                                                    <Field
                                                        className="form-control"
                                                        type="text"
                                                        name="otp"
                                                        placeholder="Enter OTP"
                                                        maxLength="6"
                                                        autoComplete="off"

                                                    />
                                                </InputGroup>
                                                <ErrorMessage
                                                    name="otp"
                                                    component="div"
                                                    className="text-error"
                                                />
                                                <InputGroup className="mb-2">
                                                    <InputGroup.Text id="basic-addon1" className="group_txt">
                                                        <FaLock className="font_size" />
                                                    </InputGroup.Text>
                                                    <input
                                                        type="password"
                                                        name="newPassword"
                                                        placeholder="Enter New Password"
                                                        className="input-field form-control"
                                                        autoComplete='off'
                                                        onChange={(e) => formIk.setFieldValue('newPassword', e.target.value)}
                                                    />

                                                </InputGroup>
                                                <ErrorMessage
                                                    name="newPassword"
                                                    component="div"
                                                    className="text-error"
                                                />
                                                <InputGroup className="mb-2">
                                                    <InputGroup.Text id="basic-addon2" className="group_txt">
                                                        <FaEyeSlash className="font_size" />
                                                    </InputGroup.Text>
                                                    <input
                                                        type="password"
                                                        name="rePassword"
                                                        placeholder="Re-Enter Password"
                                                        className="input-field form-control"
                                                        onChange={(e) => formIk.setFieldValue('rePassword', e.target.value)}
                                                    />

                                                </InputGroup>
                                                <ErrorMessage
                                                    name="rePassword"
                                                    component="div"
                                                    className="text-error"
                                                />
                                                <Button type="submit" className='w-100 sign-in-button'>
                                                    Submit
                                                </Button>
                                            </React.Fragment> : ''}
                                </Form>
                            </div>
                        </Col>

                        <Col xxl={6} xl={6} lg={6} md={12} sm={12} xs={12} className='nyay-left-part'>
                            <div className="teachers-all me-lg-5 ms-lg-3">
                                <h1>AP Teacher Eligibility
                                    Test <span>to</span> District
                                    Selection Committee</h1>
                                <p>The Andhra Pradesh Teacher Eligibility Test (APTET) is a state-level examination conducted by the Department of School Education, Government of Andhra Pradesh. It is designed to assess the eligibility of candidates aspiring to become teachers for Classes I to VIII in government, Zilla Parishad, Mandal Parishad, municipal, and private aided schools within Andhra Pradesh.</p>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>

        </FormikProvider>
    )
}
